window.addEventListener('load', function(event) {
  // console.log('ann bar script');
  const annSlider = new Swiper('.announcement-bar', {
    wrapperClass: 'announcement-bar__track',
    slideClass: 'announcement-bar__item',
    speed: 500,
    loop: true,
    slidesPerView: 1,
  });

  document.querySelectorAll('.announcement-bar__btn').forEach(arrow => {
    arrow.addEventListener('click', function(){
      if(this.classList.contains('announcement-bar__btn--prev')) {
        annSlider.slidePrev();
      }else if(this.classList.contains('announcement-bar__btn--next')) {
        annSlider.slideNext();
      }
    })
  })
}, false);